export default [
  { title: '首页', path: '/', icon: 'el-icon-menu', key: '00' },
  {
    title: '系统应用', path: '/systemMenu', icon: 'el-icon-menu', key: '001',
    children: [
      { title: '部门资料管理', path: '/systemMenu/departmentManagemen', key: '001001' },
      { title: '角色资料管理', path: '/systemMenu/roleManagement', key: '001002' },
      { title: '用户职称管理', path: '/systemMenu/titleManagement', key: '001003' },
      { title: '用户资料管理', path: '/systemMenu/userManagement', key: '001004' },
      { title: '事件日志管理', path: '/systemMenu/eventLogManagement', key: '001005' },
      { title: '在线用户列表', path: '/systemMenu/onlineUsers', key: '001006' },
      { title: '系统环境配置', path: '/systemMenu/systemConfiguration', key: '001007' },
      { title: '流程审批人设置', path: '/systemMenu/processApproverSet', key: '001008' }
    ]
  },
  {
    title: '产品管理', path: '/icItemManage', icon: 'el-icon-menu', key: '002',
    children: [
      { title: '产品列表', path: '/icItemManage/icItem', key: '002001' },

      { title: '组合列表', path: '/icItemManage/icItemZh', key: '002002' },
      { title: '组合列表录入', path: '/icItemManage/icItemZh/:id', routeOnly: true },

      { title: '解决方案列表', path: '/icItemManage/itemFa', key: '002003' },
      { title: '解决方案列表录入', path: '/icItemManage/itemFa/:id', routeOnly: true }
    ]
  },
  {
    title: '仓库管理', path: '/storeManagement', icon: 'el-icon-menu', key: '003',
    children: [
      { title: '仓库管理', path: '/storeManagement/storeManagement', key: '003001' },
      { title: '成品入库管理', path: '/storeManagement/productStoreManagement', key: '003002' },
      { title: '成品入库录入', path: '/storeManagement/productStoreManagement/:id', routeOnly: true }
    ]
  },
  {
    title: '基础信息', path: '/basicInfo', icon: 'el-icon-menu', key: '004',
    children: [
      { title: '区域名称管理', path: '/basicInfo/regionManagement', key: '004001' },
      { title: '关闭系统', path: '/basicInfo/closeSystem', key: '004002' },
      { title: '系统消息发布', path: '/basicInfo/systemNewsRelease', key: '004003' },
      { title: '区域负责人管理', path: '/basicInfo/regionDirectorManagement', key: '004006' },
      { title: '经销商信息管理', path: '/basicInfo/distributorManagement', key: '004007' },
      { title: '经销商账户管理', path: '/basicInfo/distributorBalanceManagement', key: '004008' },
      { title: '修改库存', path: '/basicInfo/inventoryModify', key: '004009' },
      { title: '产品库存', path: '/basicInfo/inventoryModify/:id', routeOnly: true },

      { title: '月末库存盘点', path: '/basicInfo/stockTaking', key: '004010' },
      { title: '入库人列表', path: '/basicInfo/incomersList', key: '004011' },
      { title: '快递公司管理', path: '/basicInfo/expressComManagement', key: '004012' },
      { title: '销售额度管理', path: '/basicInfo/salesManagement', key: '004004' },
      { title: '系统参数设置', path: '/basicInfo/systemSetup', key: '004005' },
      { title: '数据同步', path: '/basicInfo/syncData', key: '004013' }
    ]
  },
  {
    title: '业务管理', path: '/businessManagement', icon: 'el-icon-menu', key: '005',
    children: [
      { title: '客户管理', path: '/businessManagement/clientManagement', key: '005001' },
      { title: '开票管理', path: '/businessManagement/invoiceManagement', key: '005005' },
      { title: '送货单管理', path: '/businessManagement/delivery', key: '005002' },
      { title: '送货单', path: '/businessManagement/delivery/:id', routeOnly: true },
      { title: '送货单', path: '/businessManagement/delivery/v/:id', routeOnly: true },

      { title: '经销商确认', path: '/businessManagement/deliveryForJxs', key: '005003' },
      { title: '送货单(经销商确认)', path: '/businessManagement/deliveryForJxs/:id', routeOnly: true },
      { title: '送货单(经销商确认)', path: '/businessManagement/deliveryForJxs/v/:id', routeOnly: true },

      { title: '财务部确认', path: '/businessManagement/deliveryForCw', key: '005004' },
      { title: '送货单(财务部确认)', path: '/businessManagement/deliveryForCw/:id', routeOnly: true },
      { title: '送货单(财务部确认)', path: '/businessManagement/deliveryForCw/v/:id', routeOnly: true }
    ]
  },
  {
    title: '统计报表', path: '/statisticalStatement', icon: 'el-icon-menu', key: '006',
    children: [
      { title: '即时库存表', path: '/statisticalStatement/immediatelyCashStatement', key: '006006' },
      { title: '即时库存明细表', path: '/statisticalStatement/inventoryEntry', key: '006007' },
      { title: '产品入库报表', path: '/statisticalStatement/InStockReport', key: '006001' },
      { title: '产品出仓报表', path: '/statisticalStatement/OutStockReport', key: '006002' },
      { title: '产品库存报表', path: '/statisticalStatement/InventoryReport', key: '006003' },
      { title: '充值统计报表', path: '/statisticalStatement/RechargeReport', key: '006004' },
      { title: '交易统计报表 ', path: '/statisticalStatement/AchievementReport', key: '006005' },
      { title: '经销商等级变更表', path: '/statisticalStatement/DistributorRecordEntry', key: '006008' }
    ]
  },
  {
    title: '订单管理', path: '/orderManage', icon: 'el-icon-menu', key: '007',
    children: [
      { title: '草稿箱', path: '/orderManage/orderTemporary', key: '007010' },
      { title: '草稿箱录入', path: '/orderManage/orderTemporary/:id', routeOnly: true },

      { title: '我的订单', path: '/orderManage/order', key: '007001' },
      { title: '订单录入', path: '/orderManage/order/:id', routeOnly: true },
      { title: '订单查看', path: '/orderManage/order/v/:id', routeOnly: true },

      { title: '区域审核', path: '/orderManage/orderForQy', key: '007002' },
      { title: '订单(区域审核)', path: '/orderManage/orderForQy/:id', routeOnly: true },
      { title: '订单(区域审核)', path: '/orderManage/orderForQy/v/:id', routeOnly: true },

      { title: '物流部审核', path: '/orderManage/logisticsAudit', key: '007003' },
      { title: '订单(物流部审核)', path: '/orderManage/logisticsAudit/:id', routeOnly: true },
      { title: '订单(物流部审核)', path: '/orderManage/logisticsAudit/v/:id', routeOnly: true },

      { title: '会计部审核', path: '/orderManage/accountantAudit', key: '007004' },
      { title: '订单(会计部审核)', path: '/orderManage/accountantAudit/:id', routeOnly: true },
      { title: '订单(会计部审核)', path: '/orderManage/accountantAudit/v/:id', routeOnly: true },

      { title: '出纳审核', path: '/orderManage/cashierAudit', key: '007005' },
      { title: '订单(出纳审核)', path: '/orderManage/cashierAudit/:id', routeOnly: true },
      { title: '订单(出纳审核)', path: '/orderManage/cashierAudit/v/:id', routeOnly: true },

      { title: '部门确认', path: '/orderManage/warehouseAffirm', key: '007006' },
      { title: '订单(部门确认)', path: '/orderManage/warehouseAffirm/:id', routeOnly: true },
      { title: '订单(部门确认)', path: '/orderManage/warehouseAffirm/v/:id', routeOnly: true },

      { title: '物流部确认', path: '/orderManage/logisticsAffirm', key: '007007' },
      { title: '订单(物流部确认)', path: '/orderManage/logisticsAffirm/:id', routeOnly: true },
      { title: '订单(物流部确认)', path: '/orderManage/logisticsAffirm/v/:id', routeOnly: true },
      { title: '打印测试', path: '/orderManage/commonPrint' },

      { title: '仓库确认', path: '/orderManage/orderForCcbc', key: '007009' },
      { title: '订单(仓库确认)', path: '/orderManage/orderForCcbc/:id', routeOnly: true },
      { title: '订单(仓库确认)', path: '/orderManage/orderForCcbc/v/:id', routeOnly: true },

      { title: '业绩确认', path: '/orderManage/performanceAffirm', key: '007008' },
      { title: '业绩确认单', path: '/orderManage/performanceAffirm/:id', routeOnly: true },

      { title: '应收单', path: '/orderManage/arBillAffirm', key: '007011' },
      { title: '应收单确认', path: '/orderManage/arBillAffirm/:id', routeOnly: true }
    ]
  },
  {
    title: '充值管理', path: '/topUp', icon: 'el-icon-menu', key: '008',
    children: [
      { title: '新增充值单', path: '/topUp/newPrepaidPhone', key: '008001' },
      { title: '物流审核', path: '/topUp/logisticsAudit', key: '008002' },
      { title: '财务审核', path: '/topUp/financialAudit', key: '008003' }

    ]

  },
  {
    title: '退货管理', path: '/saleRetrun', icon: 'el-icon-menu', key: '009',
    children: [
      { title: '退货单', path: '/saleRetrun/saleRetrunBill', key: '009001' },
      { title: '退货单(录入)', path: '/saleRetrun/saleRetrunBill/:id', routeOnly: true },
      { title: '退货单(查看)', path: '/saleRetrun/saleRetrunBill/v/:id', routeOnly: true },

      { title: '区域审核', path: '/saleRetrun/saleRetrunBillForQY', key: '009002' },
      { title: '退货单(区域审核)', path: '/saleRetrun/saleRetrunBillForQY/:id', routeOnly: true },
      { title: '退货单(区域审核)', path: '/saleRetrun/saleRetrunBillForQY/v/:id', routeOnly: true },

      { title: '物流审核', path: '/saleRetrun/saleRetrunBillForWL', key: '009003' },
      { title: '退货单(物流审核)', path: '/saleRetrun/saleRetrunBillForWL/:id', routeOnly: true },
      { title: '退货单(物流审核)', path: '/saleRetrun/saleRetrunBillForWL/v/:id', routeOnly: true },

      { title: '会计审核', path: '/saleRetrun/saleRetrunBillForKJ', key: '009004' },
      { title: '退货单(会计审核)', path: '/saleRetrun/saleRetrunBillForKJ/:id', routeOnly: true },
      { title: '退货单(会计审核)', path: '/saleRetrun/saleRetrunBillForKJ/v/:id', routeOnly: true },

      { title: '出纳审核', path: '/saleRetrun/saleRetrunBillForCN', key: '009005' },
      { title: '退货单(出纳审核)', path: '/saleRetrun/saleRetrunBillForCN/:id', routeOnly: true },
      { title: '退货单(出纳审核)', path: '/saleRetrun/saleRetrunBillForCN/v/:id', routeOnly: true },

      { title: '部门确认', path: '/saleRetrun/saleRetrunBillForCK', key: '009006' },
      { title: '退货单(部门确认)', path: '/saleRetrun/saleRetrunBillForCK/:id', routeOnly: true },
      { title: '退货单(部门确认)', path: '/saleRetrun/saleRetrunBillForCK/v/:id', routeOnly: true },

      { title: '物流部确认', path: '/saleRetrun/saleRetrunBillForWLQ', key: '009007' },
      { title: '退货单(物流部确认)', path: '/saleRetrun/saleRetrunBillForWLQ/:id', routeOnly: true },
      { title: '退货单(物流部确认)', path: '/saleRetrun/saleRetrunBillForWLQ/v/:id', routeOnly: true },

      { title: '财务开票确认', path: '/saleRetrun/saleRetrunBillForCWQ', key: '009008' },
      { title: '退货单(财务开票确认)', path: '/saleRetrun/saleRetrunBillForCWQ/:id', routeOnly: true },
      { title: '退货单(财务开票确认)', path: '/saleRetrun/saleRetrunBillForCWQ/v/:id', routeOnly: true }
    ]

  },
  {
    title: '经销商管理', path: '/distributorManagement', icon: 'el-icon-menu', key: '010',
    children: [
      { title: '销售记录', path: '/distributorManagement/salesRecord', key: '010001' },
      { title: '销售记录(录入)', path: '/distributorManagement/salesRecord/:id', routeOnly: true },
      { title: '销售记录(查看)', path: '/distributorManagement/salesRecord/v/:id', routeOnly: true },

      { title: '销售记录审核', path: '/distributorManagement/ReviewOfSalesRecords', key: '010002' },
      { title: '销售记录审核(确认)', path: '/distributorManagement/ReviewOfSalesRecords/:id', routeOnly: true },
      { title: '销售记录审核(查看)', path: '/distributorManagement/ReviewOfSalesRecords/v/:id', routeOnly: true }

    ]
  },
  {
    title: '印章管理', path: '/controlOfStamping', icon: 'el-icon-menu', key: '00',
    children: [
      { title: '印章管理', path: '/controlOfStamping/sealManagement', key: '00' }

    ]
  }

]
